<template>
  <div ref="modalArea" :class="{'modal-area': true, 'active': reportOpen}">
    <div class="modal">
      <div class="close-modal">
        <i class="bx bx-x" @click="closeModal"></i>
      </div>
      <div ref="modalInner" class="modal-content">
        <div class="modal-header">
          {{ $t('project.report_type') }}
        </div>
        <div class="m-field">
          <select v-model="form.type" class="m-field-input">
            <option v-for="(type, ind) in types" :key="ind" :value="type.value">
              {{ type.label }}
            </option>
          </select>
          <i class="bx bxs-chevron-down m-down-icon"></i>
        </div>
        <div class="m-field">
          <textarea class="m-field-input report-textarea" rows="4" :placeholder="$t('project.reason') + '...'"></textarea>
        </div>
        <div class="buttons-area">
          <button type="button" class="button stroke-button" @click="closeModal">
            {{ $t('common.cancel') }}
          </button>
          <button v-if="!loading" type="button" class="button filled-button" @click="sendReport">
            {{ $t('common.apply') }}
          </button>
          <div v-else class="button filled-button">
            <i class="bx bx-loader-alt loading"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CommentsReportModal',
  props: {
    mid: {
      type: Number,
      default: () => null
    }
  },
  data() {
    return {
      loading: false,
      form: {
        type: '',
        reason: ''
      },
      types: [
        {
          label: this.$t('filter.select_one'),
          value: ''
        },
        {
          label: this.$t('project.spam'),
          value: 'spam'
        },
        {
          label: this.$t('project.fake'),
          value: 'fake'
        },
        {
          label: this.$t('project.link'),
          value: 'link'
        },
        {
          label: this.$t('project.abuse'),
          value: 'abuse'
        },
        {
          label: this.$t('project.private'),
          value: 'private'
        },
        {
          label: this.$t('project.other'),
          value: 'other'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('modal', [
      'reportOpen'
    ])
  },
  mounted() {
    window.addEventListener('click', this.handleClickEvents)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleClickEvents)
  },
  methods: {
    ...mapActions('modal', [
      'changeReportState'
    ]),
    ...mapActions('chat', [
      'reportMessage'
    ]),
    handleClickEvents(evt) {
      const keycode = (evt.keyCode ? evt.keyCode : evt.which)
      if (keycode === 27 && this.active === true) {
        evt.preventDefault()
        this.closeModal()
      }
      if (
        this.$refs.modalArea !== undefined &&
          this.$refs.modalArea.contains(evt.target) &&
          !this.$refs.modalInner.contains(evt.target)
      ) {
        this.closeModal()
      }
    },
    sendReport() {
      if (this.form.type.length > 0) {
        this.loading = true
        this.reportMessage({
          ...this.form,
          mid: this.mid
        }).then(() => {
          this.loading = false
          this.closeModal()
          this.form.type = ''
          this.form.reason = ''
          this.$toast.fire({
            icon: 'success',
            title: this.$t('project.reported')
          })
        }).catch((err) => {
          this.loading = false
          console.log(err.response)
          if (err.response.status !== 400) {
            this.$toast.fire({
              icon: 'warning',
              title: this.$t('project.not_reported')
            })
          } else {
            this.$toast.fire({
              icon: 'warning',
              title: this.$t('project.already_reported')
            })
          }
        })
      } else {
        this.$toast.fire({
          icon: 'info',
          title: this.$t('project.select_report_reason')
        })
      }
    },
    closeModal() {
      this.changeReportState({
        state: false
      })
      document.querySelector('body').classList.remove('scroll-none')
    }
  }
}
</script>

<style scoped>
  @import url('~/assets/css/components/modal.css');
</style>
